var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9421 3.42422L13.4087 6.35755C13.6087 6.76589 14.1421 7.15755 14.5921 7.23255L17.2504 7.67422C18.9504 7.95755 19.3504 9.19089 18.1254 10.4076L16.0587 12.4743C15.7087 12.8243 15.5171 13.4993 15.6254 13.9826L16.2171 16.5409C16.6837 18.5659 15.6087 19.3493 13.8171 18.2909L11.3254 16.8159C10.8754 16.5493 10.1337 16.5493 9.67541 16.8159L7.18375 18.2909C5.40041 19.3493 4.31708 18.5576 4.78375 16.5409L5.37541 13.9826C5.48375 13.4993 5.29208 12.8243 4.94208 12.4743L2.87541 10.4076C1.65875 9.19089 2.05041 7.95755 3.75041 7.67422L6.40875 7.23255C6.85041 7.15755 7.38375 6.76589 7.58375 6.35755L9.05041 3.42422C9.85041 1.83255 11.1504 1.83255 11.9421 3.42422Z",
    fill: "#D08759"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.8da6049cccb1d0f2eb447a06e24d357b.svg";
export { ForwardRef as ReactComponent };